import { FormField, Select, type SelectOption } from '@percent/lemonade'
import { FormSection } from '@percent/domain/giving'
import { useMemo } from 'react'

import { OpportunityLocationTypeDto } from '../../../dtos/opportunity.dto'
import type { OpportunityFormLocationSectionProps } from './opportunity-form-location-section.types'
import { VirtualLocationFields } from './virtual-location-fields'
import { OfflineLocationFields } from './offline-location-fields'

export function OpportunityFormLocationSection(
  props: Readonly<OpportunityFormLocationSectionProps>
) {
  const {
    value,
    onChange,
    touched,
    errors,
    forceReadOnly,

    sectionTitle,
    locationTypeLabel,
    locationTypePlaceholder,
    virtualLocationTypeLabel,
    inPersonLocationTypeLabel,
  } = props

  const eventLocationTypeOptions = useMemo(
    () => [
      {
        value: OpportunityLocationTypeDto.Virtual,
        label: virtualLocationTypeLabel,
      },
      {
        value: OpportunityLocationTypeDto.Offline,
        label: inPersonLocationTypeLabel,
      },
    ],
    [virtualLocationTypeLabel, inPersonLocationTypeLabel]
  )

  const handleLocationTypeChange = (event: SelectOption) => {
    onChange('locationType', event.value)

    if (event.value === OpportunityLocationTypeDto.Offline) {
      onChange('targetCountries', value.country ? [value.country] : [])
    }

    if (event.value === OpportunityLocationTypeDto.Virtual) {
      onChange('targetCountries', [])
    }
  }

  return (
    <FormSection title={sectionTitle}>
      <FormField
        necessity="required"
        label={locationTypeLabel}
        status={
          touched.locationType && errors.locationType ? 'danger' : 'default'
        }
        statusMessage={
          typeof errors.locationType === 'string'
            ? errors.locationType
            : errors.locationType?.join(', ')
        }
        data-testid="eventTypeField"
        disabled={forceReadOnly}
      >
        <Select
          defaultValue={eventLocationTypeOptions.find(
            (x) => x.value === value.locationType
          )}
          status={errors.locationType ? 'danger' : 'default'}
          placeholder={locationTypePlaceholder}
          options={eventLocationTypeOptions}
          onChange={handleLocationTypeChange}
          borderRadiiSize="large"
          disabled={forceReadOnly}
        />
      </FormField>

      {value.locationType === OpportunityLocationTypeDto.Virtual && (
        <VirtualLocationFields {...props} />
      )}

      {value.locationType === OpportunityLocationTypeDto.Offline && (
        <OfflineLocationFields {...props} />
      )}
    </FormSection>
  )
}
